import { processSteps } from "../../../mocks/siteData";

export default function ProcessSection() {
  return (
    <section className="py-0 bg-white" id="process">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 rounded-2xl overflow-hidden border border-[#EBEBEB]">
          <div className="relative" style={{ minHeight: "560px" }}>
            <img
              src="https://public.readdy.ai/ai/img_res/da30bbab5e8998bbc306e4b6c3a50bcc.jpg"
              alt="Interior design planning process"
              className="absolute inset-0 w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
            <div className="absolute bottom-8 left-8 right-8">
              <p
                className="text-white text-2xl font-semibold leading-snug"
                style={{ fontFamily: "'Playfair Display', serif" }}
              >
                &ldquo;A plan before you act saves ten mistakes after.&rdquo;
              </p>
              <p className="text-white/60 text-sm mt-2">The Design Proposal philosophy</p>
            </div>
          </div>

          <div className="bg-[#FAFAFA] p-10 lg:p-12 flex flex-col justify-center">
            <span className="inline-block text-[#C9A961] text-xs font-semibold uppercase tracking-widest mb-3">
              Simple & Clear
            </span>
            <h2
              className="text-4xl font-semibold text-[#111111] mb-10 leading-tight"
              style={{ fontFamily: "'Playfair Display', serif" }}
            >
              How Our Design Process Works
            </h2>

            <div className="space-y-8">
              {processSteps.map((step, idx) => (
                <div key={step.number} className="flex items-start gap-5">
                  <div className="shrink-0 flex flex-col items-center">
                    <div
                      className="w-10 h-10 flex items-center justify-center rounded-full bg-[#111111] text-[#C9A961] text-sm font-bold"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {step.number}
                    </div>
                    {idx < processSteps.length - 1 && (
                      <div className="w-px h-8 bg-[#EBEBEB] mt-2"></div>
                    )}
                  </div>
                  <div className="pt-1.5">
                    <h3
                      className="text-base font-semibold text-[#111111] mb-1.5"
                      style={{ fontFamily: "'Playfair Display', serif" }}
                    >
                      {step.title}
                    </h3>
                    <p className="text-sm text-[#5C5C5C] leading-relaxed">{step.description}</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
